var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import PropTypes from 'prop-types';
import cookieStorage from '../../common/CookieStorage';
import { withLocale } from '../../common/providers/LocaleProvider';
import { CookieBannerPrompt } from './CookieBannerPrompt';
import AcceptCookieClient from '../clients/AcceptCookieClient';
var CookieBanner = /** @class */ (function (_super) {
    __extends(CookieBanner, _super);
    function CookieBanner(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { showBanner: props.defaultShowBanner };
        _this.onBannerCloseClick = _this.onBannerCloseClick.bind(_this);
        _this.acceptCookie = new AcceptCookieClient();
        return _this;
    }
    CookieBanner.prototype.componentDidMount = function () {
        this.setState({
            showBanner: cookieStorage.getIsCookieBannerVisible(),
        });
    };
    CookieBanner.prototype.onBannerCloseClick = function () {
        var _this = this;
        this.setState({ showBanner: false }, function () {
            _this.acceptCookie.accept(_this.props.l10n.prefix()).catch(function () {
                // Nothing happens
            });
        });
    };
    CookieBanner.prototype.render = function () {
        var _a = this.props, l10n = _a.l10n, __legacy_shop_reboot_max_width = _a.__legacy_shop_reboot_max_width;
        var showBanner = this.state.showBanner;
        var message = l10n.r(l10n.t('h24_cookie_banner_message'), {
            h24_cookie_banner_url: l10n.prefix.t('h24_cookie_banner_url'),
        });
        return showBanner ? (React.createElement(CookieBannerPrompt, { onCloseClick: this.onBannerCloseClick, message: message, __legacy_shop_reboot_max_width: __legacy_shop_reboot_max_width })) : null;
    };
    CookieBanner.propTypes = {
        /** Should cookie banner be visible or not on the first render (default: false) */
        defaultShowBanner: PropTypes.bool,
        /** Locale context. */
        l10n: PropTypes.object,
        /** Should the max width be capped by current Reboot max width (default: true) */
        __legacy_shop_reboot_max_width: PropTypes.bool,
    };
    CookieBanner.defaultProps = {
        defaultShowBanner: false,
        __legacy_shop_reboot_max_width: true,
    };
    return CookieBanner;
}(React.Component));
export default withLocale(CookieBanner);
